import { FC } from 'react';

import { MdFileDownload } from 'react-icons/md';
import { IoCloseCircleOutline } from 'react-icons/io5';
import filesIcon from 'assets/images/Files.svg';
import { Tooltip } from 'ui/components/common';
import { Attachment } from 'utils/types';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';
import { cva } from 'class-variance-authority';

const listItemClasses = cva(
  [
    'rounded-[6px] border-[0.5px] border-separator-primary',
    'relative bg-fill-secondary',
    'flex items-center justify-center',
  ],
  {
    variants: {
      size: {
        [SIZE.Small]: ['h-10 w-10 p-[1px]'],
        [SIZE.Large]: ['h-[86px] w-[86px] p-[1px]'],
      },
    },
    defaultVariants: {
      size: SIZE.Small,
    },
  },
);

const contentClassNames = cva(
  [
    'absolute top-0',
    'bg-[#11334C60]',
    'rounded-[6px] opacity-0 hover:opacity-100',
    'flex items-center justify-center',
  ],
  {
    variants: {
      size: {
        [SIZE.Small]: ['h-10 w-10 p-[1px]'],
        [SIZE.Large]: ['h-[85px] w-[85px] p-[1px]'],
      },
    },
    defaultVariants: {
      size: SIZE.Small,
    },
  },
);

interface PROPS {
  file: Attachment;
  size: SIZE.Small | SIZE.Large;
  onDownload: () => void;
  onRemove: () => void;
  isEditing?: boolean;
}

const UploadedListItem: FC<PROPS> = ({
  size,
  file,
  onDownload,
  isEditing,
  onRemove,
}) => {
  const dimensions = size === SIZE.Large ? 85 : 40;

  return (
    <Tooltip title={file.fileName} placement="bottom">
      <div className={cn(listItemClasses({ size }))}>
        {file.fileThumbnail ? (
          <img
            src={`${file.fileThumbnail}-/preview/${dimensions}x${dimensions}/`}
            alt={file.fileName}
            className="h-full w-full rounded-[6px]"
          />
        ) : (
          <img src={filesIcon} alt={file.fileName} />
        )}
        <div className={cn(contentClassNames({ size }))}>
          {isEditing ? (
            <button
              type="button"
              onClick={onRemove}
              className={cn(
                'rounded-full bg-[#718FA5]',
                'h-9 w-9',
                'flex items-center justify-center',
              )}
            >
              <IoCloseCircleOutline className="h-6 w-5 text-white" />
            </button>
          ) : (
            <button
              type="button"
              onClick={onDownload}
              className={cn(
                'rounded-full bg-blue',
                'h-9 w-9',
                'flex items-center justify-center',
              )}
            >
              <MdFileDownload className="h-6 w-5 text-white" />
            </button>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default UploadedListItem;
